import 'shared/castle-setup';

import $ from 'jquery';
import {locale} from 'shared/core';
import {
  HoursPerWorkday,
  PolicyConfirmationModal,
} from 'main/containers/time_off';
import {BenefitsPage} from 'main/containers/benefits';
import ChargifyPaymentFormContent from 'main/containers/company_settings/billing/components/ChargifyPaymentFormContent';
import CompanyOnboardPage from 'main/containers/company_onboard/components/CompanyOnboardPage';
import CompanySettingsPage from 'main/containers/company_settings/CompanySettingsPage';
import {
  EmployeeSignupForm,
  AdminUserSignupForm
} from 'main/containers/user_signup';

import {EmployeeProfilePage} from 'main/containers/employees/profile';
import {EmployeeDirectoryPage} from 'main/containers/employees/directory';
import GlobalSearchContainer from 'main/containers/global_search';
import {GoalPage} from 'main/containers/performance_goals';
import InboxPage from 'main/containers/inbox';
import JobApplicationContainer from 'main/containers/recruiting/components/job_application/JobApplicationContainer';
import {JobOfferContainer} from 'main/containers/job_offer';
import ScheduleInterviewPage from 'main/containers/recruiting/components/schedule_interview/ScheduleInterviewPage';
import {LoginContainer, MFASetupContainer} from 'main/containers/login/components';
import OffersPage from 'main/containers/offers';
import OnboardBankingContainer from 'main/containers/onboard/banking/components/OnboardBankingContainer';
import OnboardCoverageContainer from 'main/containers/onboard/coverage';
import OnboardEmergencyContainer    from 'main/containers/onboard/emergency/components/OnboardEmergencyContainer';
import OnboardEmployeeDocumentsPage from 'main/containers/onboard/documents/components/OnboardEmployeeDocumentsPage';
import OnboardEmployeeInfoContainer from 'main/containers/onboard/employee_info/components/OnboardEmployeeInfoContainer';
import OnboardFamilyStatusContainer from 'main/containers/onboard/family_status';
import OnboardingTrainingContainer from 'main/containers/employees/hiring/components/OnboardingTrainingContainer';
import {OnboardBenefitInfoReviewPage} from 'main/containers/onboard';
import PayrollPage from 'main/containers/payroll';
import PasswordReset from 'main/containers/password_reset';
import PendingDocumentsPage from 'main/containers/pending_documents/components/PendingDocumentsPage';
import PerformanceManagementPage from 'main/containers/performance';
import RecruitingPage from 'main/containers/recruiting';
import ReferralsPage from 'main/containers/referrals';
import ReportsPage from 'main/containers/reports';
import SecureUploadPage from 'main/containers/secure_upload';
import {SurveysPage} from 'main/containers/surveys';
import {TimeTrackingPage} from 'main/containers/time_tracking';
import {ExpensesPage} from 'main/containers/expenses';
import StyleGuideContainer from 'main/containers/styleguide/components/StyleGuideContainer';
import {TimeOffPage} from 'main/containers/time_off';
import TrainingPage from 'main/containers/training';
import {SignUpPage} from 'main/containers/signup';
import {PerformanceReviewsPage} from 'main/containers/performance_reviews';
import {ExternalCandidatesContainer} from 'main/containers/integrations/external_candidates';
import {MarketplaceContainer} from 'main/containers/integrations/marketplace';
import PayrollUpdatesPage from 'main/containers/payroll_updates';
import {TrialEndedPage} from 'main/containers/billing_subscriptions';
import {HRDashboardPage} from 'main/containers/hr_dashboard';

import {
  DelayRender,
  LocaleSelect,
  NotAuthorized,
} from 'shared/components';
import {StopImpersonation} from 'main/components';
import setupSentry from 'shared/sentry-setup';
import i18n from 'shared/i18n';
import moment from 'moment';
import 'moment/src/locale/fr';
import numeral from 'numeral';
import 'numeral/locales';
import {setSessionExpirationTimeout} from 'shared/core/sessionExpirationTimeout';
import {setupSessionExpirationUI} from 'main/tools/sessionExpirationUI';
import {renderIfNeeded, setSidebarCloseCallback, relativeCalendar} from 'shared/tools';
import Modal from 'react-modal';
import DemoBanner from 'main/components/demo_banner/components/DemoBanner';
import FeatureRequestModal from 'main/components/feature_request/FeatureRequestModal';
import {DemoDataDeletion} from 'main/containers/demo_data_deletion';
import {UserActivation, ConfirmationCodeForm} from 'main/containers/user_activation';
import MassUpdatesPage from 'main/containers/mass_updates';
import UserSettingsContainer from 'main/containers/users/settings/components/UserSettingsContainer';
import Setup from 'main/containers/nmbr/components/Setup';
import CalendarPage from 'main/containers/calendar';
import {RequestPage} from 'main/containers/time_off/components';
import './tailwind.css';
import configureMobX from 'shared/mobx-configuration';

setupSentry();
configureMobX();
i18n.init(locale);
moment.locale(locale);
moment.calendarFormat = relativeCalendar;
numeral.locale(locale);
Modal.setAppElement('body');

const bindJsLinks = () => {
  $(document).on('click', '.js-link', function (e) {
    e.preventDefault();
    window.location = $(this).data('link');
  });
};

renderIfNeeded(AdminUserSignupForm, 'cr-admin-invitation-signup');
renderIfNeeded(BenefitsPage, 'cr-benefits');
renderIfNeeded(ChargifyPaymentFormContent, 'cr-chargify-payment-form');
renderIfNeeded(CompanyOnboardPage, 'cr-company-setup');
renderIfNeeded(CompanySettingsPage, 'cr-company-settings');
renderIfNeeded(DelayRender, 'cr-delay-render');
renderIfNeeded(DemoBanner, 'cr-demo-banner');
renderIfNeeded(EmployeeDirectoryPage, 'cr-employee-directory');
renderIfNeeded(EmployeeProfilePage, 'cr-employee-profile');
renderIfNeeded(EmployeeSignupForm, 'cr-bhq-employee-signup');
renderIfNeeded(MarketplaceContainer, 'cr-marketplace-index');
renderIfNeeded(ExternalCandidatesContainer, 'cr-greenhouse-index', {vendor: 'greenhouse'});
renderIfNeeded(ExternalCandidatesContainer, 'cr-jazz-hr-index', {vendor: 'jazz_hr'});
renderIfNeeded(GlobalSearchContainer, 'cr-global-search');
renderIfNeeded(GoalPage, 'cr-goals-page');
renderIfNeeded(UserSettingsContainer, 'cr-user-settings');
renderIfNeeded(UserActivation, 'cr-user-activations');
renderIfNeeded(ConfirmationCodeForm, 'cr-confirmation-code-form');
renderIfNeeded(HoursPerWorkday, 'cr-pto-policy-hours-per-workday');
renderIfNeeded(InboxPage, 'cr-inbox');
renderIfNeeded(JobApplicationContainer, 'cr-job-application');
renderIfNeeded(JobOfferContainer, 'cr-job-offer');
renderIfNeeded(LocaleSelect, 'cr-locale-select');
renderIfNeeded(MassUpdatesPage, 'cr-mass-salary-updates');
renderIfNeeded(MFASetupContainer, 'cr-mfa-setup');
renderIfNeeded(LoginContainer, 'cr-login');
renderIfNeeded(OffersPage, 'cr-offers-page');
renderIfNeeded(OnboardBankingContainer, 'cr-onboard-banking');
renderIfNeeded(OnboardBenefitInfoReviewPage, 'cr-onboarding-benefit-info-review');
renderIfNeeded(OnboardCoverageContainer, 'onboard-coverage', { onboardStep: 'coverage' });
renderIfNeeded(OnboardEmergencyContainer, 'cr-onboard-emergency');
renderIfNeeded(OnboardEmployeeDocumentsPage, 'cr-onboard-employee-documents');
renderIfNeeded(OnboardEmployeeInfoContainer, 'cr-onboard-employee-info');
renderIfNeeded(OnboardFamilyStatusContainer, 'onboard-family-status', { onboardStep: 'family_status' });
renderIfNeeded(OnboardingTrainingContainer, 'cr-onboarding-training');
renderIfNeeded(PayrollPage, 'cr-payroll-page');
renderIfNeeded(PayrollUpdatesPage, 'cr-payroll-updates-page');
renderIfNeeded(PendingDocumentsPage, 'cr-pending-documents');
renderIfNeeded(PerformanceManagementPage, 'cr-performance-page');
renderIfNeeded(PerformanceReviewsPage, 'cr-reviews-page');
renderIfNeeded(PolicyConfirmationModal, 'cr-pto-policy-confirmation-modal');
renderIfNeeded(RecruitingPage, 'cr-recruiting-page');
renderIfNeeded(ReferralsPage, 'cr-referrals-page');
renderIfNeeded(ReportsPage, 'cr-reports-page');
renderIfNeeded(SecureUploadPage, 'cr-secure-upload');
renderIfNeeded(SignUpPage, 'cr-company-sign-up');
renderIfNeeded(StopImpersonation, 'cr-stop-impersonation');
renderIfNeeded(StyleGuideContainer, 'cr-styleguide');
renderIfNeeded(SurveysPage, 'cr-surveys-page');
renderIfNeeded(TimeTrackingPage, 'cr-time-tracking');
renderIfNeeded(ExpensesPage, 'cr-expenses');
renderIfNeeded(TimeOffPage, 'cr-pto');
renderIfNeeded(RequestPage, 'cr-pto-show-request');
renderIfNeeded(TrainingPage, 'cr-training-page');
renderIfNeeded(FeatureRequestModal, 'cr-feature-request-modal');
renderIfNeeded(TrialEndedPage, 'cr-trial-ended-page');
renderIfNeeded(NotAuthorized, 'cr-not-authorized');
renderIfNeeded(HRDashboardPage, 'cr-hr-dashboard-page');
renderIfNeeded(DemoDataDeletion, 'cr-demo-data-deletion');
renderIfNeeded(Setup, 'cr-nmbr-setup');
renderIfNeeded(CalendarPage, 'cr-calendar');
renderIfNeeded(PasswordReset, 'cr-password-reset');
renderIfNeeded(ScheduleInterviewPage, 'cr-interview-invite');

setupSessionExpirationUI();
setSessionExpirationTimeout();
setSidebarCloseCallback();

bindJsLinks();
